"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFadeIn = useFadeIn;
exports.useFadeOut = useFadeOut;
exports.useFlushFromLeft = useFlushFromLeft;
exports.usePeekFromBottom = usePeekFromBottom;
exports.useVirtualizedList = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactSpring = require("react-spring");
var _diff = require("diff");
var _previous = _interopRequireDefault(require("./previous"));
var _excluded = ["from", "to"],
  _excluded2 = ["y", "height"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useFadeIn() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$from = _ref.from,
    from = _ref$from === void 0 ? {} : _ref$from,
    _ref$to = _ref.to,
    to = _ref$to === void 0 ? {} : _ref$to,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return (0, _reactSpring.useSpring)(_objectSpread({
    from: _objectSpread({
      opacity: 0
    }, from),
    to: _objectSpread({
      opacity: 1
    }, to)
  }, rest));
}
function useFadeOut() {
  return (0, _reactSpring.useSpring)({
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    }
  });
}
function useFlushFromLeft(nodes) {
  var trail = (0, _reactSpring.useTrail)(nodes.length, {
    from: {
      y: -100,
      opacity: 0
    },
    to: {
      y: 0,
      opacity: 1
    },
    config: {
      tension: 300
    }
  });
  return trail.map(function (_ref2, index) {
    var y = _ref2.y,
      height = _ref2.height,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
    return /*#__PURE__*/_react["default"].createElement(_reactSpring.a.div, {
      key: index,
      style: _objectSpread(_objectSpread({}, rest), {}, {
        transform: y.interpolate(function (y) {
          return "translate3d(".concat(y, "px,0,0)");
        })
      })
    }, /*#__PURE__*/_react["default"].createElement(_reactSpring.a.div, {
      style: {
        height: height
      }
    }, nodes[index]));
  });
}
function usePeekFromBottom() {
  return (0, _reactSpring.useSpring)({
    from: {
      height: '0%',
      opacity: 0
    },
    to: {
      height: '100%',
      opacity: 1
    }
  });
}
var useVirtualizedList = exports.useVirtualizedList = function useVirtualizedList(list, keys) {
  var _useState = (0, _react.useState)({
      data: list,
      removedIndexes: []
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var previousList = (0, _previous["default"])(list);
  var durationRef = (0, _react.useRef)(0);
  (0, _react.useEffect)(function () {
    var root = document.querySelector(':root');
    var rootStyle = window.getComputedStyle(root);
    durationRef.current = Number.parseInt(rootStyle.getPropertyValue('--animation-duration'));
  }, []);
  (0, _react.useEffect)(function () {
    list.forEach(function (item) {
      return item._className = '';
    });
    if (previousList === list || !list.length) {
      setState({
        data: list,
        removedIndexes: []
      });
      return;
    }
    var diff = (0, _diff.diffArrays)(previousList, list, {
      comparator: function comparator(left, right) {
        return keys.every(function (item) {
          return left[item] === right[item];
        });
      }
    });
    var removedItems = diff.filter(function (item) {
      return item.removed;
    }).map(function (item) {
      return item.value;
    }).reduce(function (prev, curr) {
      return [].concat((0, _toConsumableArray2["default"])(prev), (0, _toConsumableArray2["default"])(curr));
    }, []);
    var addedItems = diff.filter(function (item) {
      return item.added;
    }).map(function (item) {
      return item.value;
    }).reduce(function (prev, curr) {
      return [].concat((0, _toConsumableArray2["default"])(prev), (0, _toConsumableArray2["default"])(curr));
    }, []);
    if (!removedItems.length && !addedItems.length) {
      setState({
        data: list,
        removedIndexes: []
      });
      return;
    }
    if (removedItems.length && !addedItems.length) {
      var newRemovedIndexes = removedItems.map(function (item) {
        return previousList.indexOf(item);
      });
      removedItems.forEach(function (item) {
        return item._className = 'removed';
      });
      setState({
        data: previousList,
        removedIndexes: newRemovedIndexes
      });
      setTimeout(function () {
        setState({
          data: list,
          removedIndexes: []
        });
      }, durationRef.current);
    } else {
      setState({
        data: list,
        removedIndexes: []
      });
    }
  }, [list]);
  return state;
};
//# sourceMappingURL=animations.js.map